import React from 'react';
import SmartNavbar from '../components/SmartNavbar';
import PricingSection from '../components/PricingSection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const Pricing = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="Pricing - Snaptura API"
        description="Simple, transparent pricing for Snaptura screenshot and PDF generation API. Start free with 100 requests/month. Scale up with Starter ($29/mo) or Pro ($99/mo) plans."
        url="/pricing"
      />
      <SmartNavbar />
      <PricingSection />
      <Footer />
    </div>
  );
};

export default Pricing;